import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ReportService } from '../../services/API/orchestrator-patient/report.service';
import { SelectedLocationRequest } from '../../services/requests/orchestrator-queue/selected-location.request';
import { ObservationForwardBedConfirmModalComponent } from './observation-forward-bed-confirm-modal/observation-forward-bed-confirm-modal.component';
import { ObservationForwardConfirmModalComponent } from './observation-forward-confirm-modal/observation-forward-confirm-modal.component';
import { UtilService } from '../../services/util.service';
import { MedicalCareSadtStruct } from '../../services/structs/medical-record/medical-care-sadt.struct';

@Component({
    selector: 'app-observation-forward-modal',
    templateUrl: './observation-forward-modal.component.html',
    styleUrls: ['./observation-forward-modal.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ObservationForwardModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public matDialogRef: MatDialogRef<ObservationForwardModalComponent>,
    public reportService: ReportService,
    public router: Router,
    public utilService: UtilService,
  ) { }

  public isLoading: boolean = true;
  public model: FormGroup;
  public selectedLocationRequest: SelectedLocationRequest;
  public listSadtOpen: MedicalCareSadtStruct[] = this.data.listSadtOpen;
  public isFlowSequence: boolean = this.data.isFlowSequence;
  public filteredListforward: any[] = [];
  public listForward: any[] = [];
  public searchText: string;

  ngOnInit(): void {
    if (this.isFlowSequence && this.data.flowSequence.length > 1) {
      var destinyRoomName = this.data.flowSequence[1].destinyRoomName ? this.data.flowSequence[1].destinyRoomName : "";
      var destinySectorName = this.data.flowSequence[1].destinySectorName ? this.data.flowSequence[1].destinySectorName + " " : "";
      var destinyServiceName = this.data.flowSequence[1].destinyServiceName ? this.data.flowSequence[1].destinyServiceName : " ";
      this.listForward = [{ idFlow: this.data.flowSequence[1].idFlow, locationName: destinyServiceName + destinySectorName + destinyRoomName }];
      this.filteredListforward = [...this.listForward]
    }
    else if (this.data.listFoward) {
      this.listForward = this.data.listFoward;
      this.filteredListforward = [...this.data.listFoward];
    }

    this.isLoading = false;
  }

  close() {
    this.clickCancel();
  }

  clickCancel() {
    this.matDialogRef.close({ fowardPatient: false });
  }

  onKeySearch() {
    setTimeout(() => {
      if (this.searchText) {
        this.filteredListforward = [...this.listForward.filter((item: any) => {
          return item.locationName.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1;
        })];
      }
      else
        this.filteredListforward = [...this.listForward];
    });
  }

  selectItem(idFlow: number) {
    if (this.isLoading)
      return;

    this.isLoading = true;

    this.selectedLocationRequest = new SelectedLocationRequest();

    this.selectedLocationRequest.idEpisode = this.data.idEpisode;
    this.selectedLocationRequest.idQueue = this.data.idQueue;
    this.selectedLocationRequest.idFlow = idFlow;
    this.selectedLocationRequest.idParentService = this.data.idService;
    this.selectedLocationRequest.idRoomOrigin = this.data.actualIdRoom;
    let roomName = this.data.listFoward.find(c => c.idFlow == this.selectedLocationRequest.idFlow).locationName;

    if (this.isFlowSequence)
      this.selectedLocationRequest.idFlowCompleted = this.data.flowSequence[0].idFlow;

    if (this.data.isMedicBedManagement)
      this.openForwardConfirmModal();
    else {
      if (this.data.idBed)
        this.openForwardBedConfirmModal(roomName);
      else
        this.openForwardConfirmModal();
    }
  }

  openForwardConfirmModal() {
    const dialogRef = this.dialog.open(ObservationForwardConfirmModalComponent, {
      disableClose: true,
      data: {
        idHealthUnit: this.data.idHealthUnit,
        selectedLocationRequest: this.selectedLocationRequest,
        idEpisode: this.data.idEpisode,
        idRoom: this.data.actualIdRoom,
        datetimeStartRegister: this.data.datetimeStartRegister,
        idBed: this.data.idBed,
      },
    });
    dialogRef.afterClosed().subscribe({
      next: result => {
        this.isLoading = false;
        if (result && result.fowardPatient)
          this.matDialogRef.close({ fowardPatient: true });
      },
      error: (error) => {
        this.utilService.consoleLog(error);
      }
    });
  }

  openForwardBedConfirmModal(locationName) {
    const dialogRef = this.dialog.open(ObservationForwardBedConfirmModalComponent, {
      data: {
        idHealthUnit: this.data.idHealthUnit,
        selectedLocationRequest: this.selectedLocationRequest,
        idEpisode: this.data.idEpisode,
        idRoom: this.data.actualIdRoom,
        datetimeStartRegister: this.data.datetimeStartRegister,
        idBed: this.data.idBed,
        locationName: locationName,
      },
    });
    dialogRef.afterClosed().subscribe({
      next: result => {
        this.isLoading = false;
        if (result && result.fowardPatient)
          this.matDialogRef.close({ fowardPatient: true });
      },
      error: (error) => {
        this.utilService.consoleLog(error);
      }
    });
  }
}